// removed by extract-text-webpack-plugin
module.exports = {"Loader":"spinner__Loader__vHJC6","load2":"spinner__load2__fau2i","Middle":"spinner__Middle__1UMhf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/spinner/spinner.css
// module id = 129
// module chunks = 3